import { JRCFileViewer } from '../JRCFileViewer/JRCFileViewer';
import { getFileFamily } from 'jamespot-user-api';
import React, { Fragment, useMemo } from 'react';

import { JRCAlbumProps } from './types';
import { AlbumX1 } from './components/AlbumX1';
import { AlbumX2 } from './components/AlbumX2';
import { AlbumX3 } from './components/AlbumX3';
import { AlbumX4 } from './components/AlbumX4';
import { AlbumX5 } from './components/AlbumX5';
import { AlbumAttachments, AlbumWrapper } from './styles';
import { ALBUM_DEFAULT_MAX_WIDTH, ALBUM_SUPPORTED_FILE_FAMILY } from './const';
import { JRCAttachments } from 'components/JRCAttachments/JRCAttachments';

export const JRCAlbum = ({
    files,
    maxWidth = ALBUM_DEFAULT_MAX_WIDTH,
    withAttachments = false,
    urlResolve,
}: JRCAlbumProps) => {
    const size = `fitx${maxWidth}`;
    const { album, attachments, filesViewer } = useMemo(() => {
        return {
            album: files
                .filter((file) => ALBUM_SUPPORTED_FILE_FAMILY.includes(getFileFamily(file.mimetype)))
                .map((file) => {
                    return {
                        uri: urlResolve(file),
                        mimetype: file.mimetype,
                        title: file.title,
                        id: file.id,
                        size,
                    };
                }),
            attachments: files.filter((file) => !ALBUM_SUPPORTED_FILE_FAMILY.includes(getFileFamily(file.mimetype))),
            filesViewer: files.map((file) => {
                return { ...file, path: urlResolve(file) };
            }),
        };
    }, [files, size, urlResolve]);

    return (
        <Fragment>
            <JRCFileViewer files={filesViewer} openWithOptions={[]}>
                {(open) => {
                    return (
                        <AlbumWrapper>
                            {album.length === 1 && <AlbumX1 files={album} maxWidth={maxWidth} onClick={open} />}
                            {album.length === 2 && <AlbumX2 files={album} maxWidth={maxWidth} onClick={open} />}
                            {album.length === 3 && <AlbumX3 files={album} maxWidth={maxWidth} onClick={open} />}
                            {album.length === 4 && <AlbumX4 files={album} maxWidth={maxWidth} onClick={open} />}
                            {album.length >= 5 && <AlbumX5 files={album} maxWidth={maxWidth} onClick={open} />}
                        </AlbumWrapper>
                    );
                }}
            </JRCFileViewer>
            {withAttachments && attachments.length !== 0 && (
                <AlbumAttachments>
                    <JRCAttachments files={attachments} />
                </AlbumAttachments>
            )}
        </Fragment>
    );
};
